import { ref } from "vue";
import type { ScanKind, ScanResult } from "./types";

/**
 * A scan opened on another page ("open as invoice" from Deliveries): the
 * target page takes it on mount.
 */
export const pendingScan = ref<{ kind: ScanKind; result: ScanResult } | null>(null);

export function takePendingScan(kind: ScanKind): ScanResult | null {
  const p = pendingScan.value;
  if (!p || p.kind !== kind) return null;
  pendingScan.value = null;
  return p.result;
}
